import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { PanelPatientDataDisplay } from '../sharedPanelComponents/PanelPatientDataDisplay'
import { getPCCCoverages, getPCCData } from '../../../../../helper/pccApiHelper'
import { PatientInsuranceDisplay } from '../../../../../components/common/shared/sharedPatientCode'
import { CSpinner } from '@coreui/react-pro'

const getPccInsuranceInformation = async (patientId, onSuccess) => {
  const pccData = await getPCCData(patientId)
  const pccCoverages = await getPCCCoverages(patientId)
  if (pccData) {
    onSuccess({ ...pccData, coverages: pccCoverages })
  }
}

export default function PanelPatientInsurance() {
  const patientId = useSelector((state) => state.sidePanel.panelEncounter?.patient_id)

  const [insuranceInfoData, setInsuranceInfoData] = useState({})
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (patientId) {
      getPccInsuranceInformation(patientId, setInsuranceInfoData).then(() => setIsLoading(false))
    }
  }, [patientId])

  return (
    <div id={'PanelPatientInsurance'} className={`display-box `}>
      {isLoading ? (
        <div className={'d-flex justify-content-center'}>
          <CSpinner />
        </div>
      ) : Object.keys(insuranceInfoData).length === 0 ? (
        'No Data Found'
      ) : (
        <PatientInsuranceDisplay
          insuranceInfoData={insuranceInfoData}
          DisplayFunction={PanelPatientDataDisplay}
        />
      )}
    </div>
  )
}
